
















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

const LOAD_TIMEOUT = 15000;

@Component
export default class Iframe extends Vue {
  @Prop({type: String, required: true}) readonly link!: string;

  @Prop({type: String, required: true}) readonly title!: string;

  hasError = false;

  isLoading = true;

  reloadKey = 0;

  timeoutId: number | null = null;

  mounted(): void {
    this.startTimer();
  }

  beforeDestroy(): void {
    this.clearTimer();
  }

  @Watch('link')
  onLinkChange(): void {
    this.startTimer();
  }

  onLoad(): void {
    this.clearTimer();
    this.hasError = false;
    this.isLoading = false;
  }

  retry(): void {
    this.reloadKey += 1;
    this.startTimer();
  }

  startTimer(): void {
    this.clearTimer();
    this.hasError = false;
    this.isLoading = true;
    this.timeoutId = window.setTimeout(() => {
      this.hasError = true;
      this.isLoading = false;
    }, LOAD_TIMEOUT);
  }

  clearTimer(): void {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
}
